module.exports = __webpack_public_path__ + "static/media/blockm-icon.91a2534d.png";